import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyDocUpload from "./component";
import { withRouter } from "react-router-dom";
import { diyPaymentApprovalProcess } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        postTokenDocuments,
        inspectionResponse
    }
}) => ({
    postTokenDocuments,
    inspectionResponse
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    diyPaymentApprovalProcessConnect: diyPaymentApprovalProcess
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyDocUpload));
